// src/components/UserTypeList.js
import React from 'react';
import PropTypes from 'prop-types';
import { FaEdit, FaTrash, FaUser } from 'react-icons/fa';

function UserTypeList({
  title, users, onEdit, onDelete,
}) {
  // Ordenar los usuarios alfabéticamente por nombre de usuario
  const sortedUsers = [...users].sort((a, b) => a.username.localeCompare(b.username));

  return (
    <div className="w-full h-full flex flex-col">
      <h2 className="text-xl font-semibold text-gray-800 mb-4 px-1">{title}</h2>
      <div
        className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pr-2"
        style={{ height: 'calc(100vh - 300px)' }}
      >
        <div className="space-y-3 min-h-full">
          {sortedUsers.map((user) => (
            <div
              key={user.id}
              className="bg-white border border-gray-100 rounded-lg p-4 transition-all duration-200
              hover:shadow-md hover:border-gray-200 hover:-translate-y-0.5 group"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="bg-gray-50 rounded-full p-2 group-hover:bg-blue-50 transition-colors duration-200">
                    <FaUser className="text-gray-400 group-hover:text-blue-500 w-4 h-4" />
                  </div>
                  <div>
                    <h3 className="text-gray-800 font-medium">{user.username}</h3>
                    <p className="text-xs text-gray-500 mt-0.5">{user.role}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => onEdit(user.id)}
                    type="button"
                    className="p-2 text-gray-400 hover:text-blue-500 transition-colors duration-200
                    rounded-full hover:bg-blue-50"
                    aria-label="Editar usuario"
                  >
                    <FaEdit className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => onDelete(user.id)}
                    type="button"
                    className="p-2 text-gray-400 hover:text-red-500 transition-colors duration-200
                    rounded-full hover:bg-red-50"
                    aria-label="Eliminar usuario"
                  >
                    <FaTrash className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

UserTypeList.propTypes = {
  title: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  })).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default UserTypeList;
